import type { HostSortMode } from '@/mocks/liveHosts';

interface HostLiveSortBarProps {
  currentSort: HostSortMode;
  onSortChange: (mode: HostSortMode) => void;
  totalCount: number;
  totalRadios: number;
}

const sortOptions: { mode: HostSortMode; label: string; icon: string }[] = [
  { mode: 'activity', label: 'Actividad', icon: 'ri-flashlight-line' },
  { mode: 'followers', label: 'Seguidores', icon: 'ri-group-line' },
  { mode: 'name', label: 'Nombre A-Z', icon: 'ri-sort-alphabet-asc' },
];

export default function HostLiveSortBar({ currentSort, onSortChange, totalCount, totalRadios }: HostLiveSortBarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-1 bg-background-100 rounded-xl p-1">
        {sortOptions.map((opt) => (
          <button
            key={opt.mode}
            onClick={() => onSortChange(opt.mode)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap transition-all cursor-pointer ${
              currentSort === opt.mode
                ? 'bg-background-50 text-primary-600 shadow-sm'
                : 'text-foreground-400 hover:text-foreground-600'
            }`}
          >
            <i className={`${opt.icon} text-xs`}></i>
            {opt.label}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
          <span className="text-[11px] font-bold text-foreground-600">{totalCount} locutores al aire</span>
        </div>
        <div className="w-px h-4 bg-background-200"></div>
        <span className="text-[11px] font-semibold text-foreground-400 flex items-center gap-1">
          <i className="ri-radio-line text-[11px]"></i>
          en {totalRadios} radios
        </span>
      </div>
    </div>
  );
}